import React from 'react';
import Box from '@mui/material/Box';

// Shared comparison-table marks: outlined green check (yes) and outlined grey cross (no).
// Used across comparison tables for a consistent look.

export function CheckCircle({ size = 22 }) {
    return (
        <Box component="svg" viewBox="0 0 24 24" sx={{ width: size, height: size, flex: 'none' }}>
            <circle cx="12" cy="12" r="10" fill="none" stroke="#20AB09" strokeWidth="2" />
            <path
                d="M7.6 12.3l2.9 2.9 6-6"
                stroke="#20AB09"
                strokeWidth="2.2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Box>
    );
}

export function CrossCircle({ size = 22 }) {
    return (
        <Box component="svg" viewBox="0 0 24 24" sx={{ width: size, height: size, flex: 'none' }}>
            <circle cx="12" cy="12" r="10" fill="none" stroke="#c9c6d1" strokeWidth="2" />
            <path d="M9 9l6 6M15 9l-6 6" stroke="#c9c6d1" strokeWidth="2" strokeLinecap="round" />
        </Box>
    );
}
